import { create } from "zustand";

// Live LTE modem signal per node, indexed by current_node_id. Backs the
// per-tile signal indicator. The modem agent reports ~every 60s, so a 60s
// poll of /api/modems is plenty fresh and far cheaper than threading it
// through the realtime WS.
export type ModemSignal = {
  modem_id: string;
  current_node_id: string | null;
  rsrp: number | null;
  rsrq: number | null;
  sinr: number | null;
  csq: number | null;
  band: string | null;
  operator: string | null;
  network: string | null;
  edge_updated_at: string | null;
};

type State = {
  byNode: Record<string, ModemSignal>;
  start: () => void;
};

let started = false;

export const useModemSignals = create<State>((set) => ({
  byNode: {},
  start: () => {
    if (started) return;
    started = true;
    const load = async () => {
      try {
        const r = await fetch("/api/modems");
        if (!r.ok) return;
        const data = await r.json();
        const byNode: Record<string, ModemSignal> = {};
        for (const m of data.modems ?? []) {
          const node = m.current_node_id;
          // Only surface fresh cellular modems (not wired / not stale).
          if (!node || !m.network || /wired/i.test(m.network)) continue;
          if (m.edge_updated_at) {
            const age = Date.now() - new Date(m.edge_updated_at).getTime();
            if (age > 10 * 60 * 1000) continue;
          }
          byNode[node] = m;
        }
        set({ byNode });
      } catch {
        /* transient — keep the last good map */
      }
    };
    load();
    setInterval(load, 60_000);
  },
}));
